import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOMeta from "@/components/SEOMeta";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Home, Wrench, Hammer, Grid } from "lucide-react";

const Welland = () => {
  const services = [
    { title: "Fence Installation", icon: Home, link: "/services/deck-fence" },
    { title: "Deck Building", icon: Wrench, link: "/services/deck-fence" },
    { title: "Drywall Services", icon: Grid, link: "/services/drywall" },
    { title: "Flooring Installation", icon: Home, link: "/services/flooring" },
    { title: "Carpentry", icon: Hammer, link: "/services/carpenter" },
    { title: "General Contracting", icon: Wrench, link: "/services/general-contracting" }
  ];

  return (
    <>
      <SEOMeta 
        title="General Contractor in Welland — Skilled Trades & Renovations"
        description="Welland general contracting and skilled trades. Carpentry, plumbing, electrical, HVAC, roofing and more for residential and commercial projects."
        keywords="general contractor Welland, Welland construction, contracting services, fence installation, deck building, drywall, flooring"
        canonicalUrl="https://blueknightcontracting.ca/welland"
      />
      
      <LocalBusinessSchema 
        locationName="Welland"
        addressLocality="Welland"
        addressRegion="ON"
        postalCode="L3B"
        description="Welland general contracting and skilled trades. Carpentry, plumbing, electrical, HVAC, roofing and more for residential and commercial projects."
        services={[
          "General Contracting",
          "Fence Installation",
          "Deck Building",
          "Drywall Services",
          "Flooring Installation",
          "Carpentry Services"
        ]}
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        
        <section className="relative bg-gradient-to-br from-primary to-primary/80 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl lg:text-6xl font-bold mb-6">
                General Contractor in Welland
              </h1>
              <p className="text-xl mb-8 opacity-90">
                Welland general contracting and skilled trades. Carpentry, plumbing, electrical, HVAC, roofing and more for residential and commercial projects.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" variant="secondary">
                  <Link to="/contact">Get Free Quote</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
                  <Link to="/services">View All Services</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Our Services in Welland
              </h2>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                Professional construction and skilled trades for Welland homes and businesses
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <Card key={index} className="h-full hover:shadow-lg transition-shadow">
                  <CardHeader>
                    <service.icon className="h-12 w-12 text-primary mb-4" />
                    <CardTitle>{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Button asChild variant="link" className="px-0">
                      <Link to={service.link}>Learn More →</Link>
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-primary text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Need a Contractor in Welland?
            </h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Contact Blue Knight Contracting for professional construction services in Welland. Licensed, insured and locally trusted.
            </p>
            <Button asChild size="lg" variant="secondary">
              <Link to="/contact">Get Free Quote Today</Link>
            </Button>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Welland;
